import React from "react";

import { OrderDetailsOverlayWrapper, OrderDetailsWrapper } from "../../orderHistory.styles";
import { OrderTopSectopmWrap } from "../../../catalogue/items/components/catalogue.styles";
import { CloseIcon } from "../../../../../AuthenticatedApp/components/productCatalogue/common/images/Icons";
import OrderItems from "./OrderItems";
import TotalSummaryCharge from "./TotalSummary";

const OrderDetails = ({ orderData, closeOrderDetails, totalPrice }) => {
    return (
        <OrderDetailsOverlayWrapper>
            <OrderDetailsWrapper>
                <OrderTopSectopmWrap>
                    <div>
                        <h3>Order Details</h3>
                        <p>Order No: {orderData?.orderID} </p>
                    </div>
                    <div className="sales__order-history-close" onClick={closeOrderDetails}>
                        <CloseIcon />
                    </div>
                </OrderTopSectopmWrap>
                <OrderItems {...{ orderData }} />
                <TotalSummaryCharge {...{ orderData, totalPrice }} />
            </OrderDetailsWrapper>
        </OrderDetailsOverlayWrapper>
    );
};

export default OrderDetails;
